import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import authContext from "../../../../AuthContext/authContext";
import EditGuard from "./EditGuard";
import Home from "../../Common/Home/Home";
const base_url = process.env.REACT_APP_BASE_URL;
const EditGuardWrapper = () => {
  const activeEditEmployeeId = useSelector(
    (state) => state.appData.activeEditEmployeeId
  );
  console.log(activeEditEmployeeId, "activeEditEmployeeId");
  const ctx = useContext(authContext);
  const token = ctx.token;
  const [initialData, setInitialData] = useState({});
// console.log(activeEditEmployeeId, "activeEditEmployeeId");
  useEffect(() => {
    let reqObj = {
      method: "GET",
      url: `${base_url}/auth/guard/${activeEditEmployeeId}`,
      headers: {
        "Content-Type": "application/javascript",
        Authorization: `Bearer ${token}`,
      },
    };

    axios(reqObj)
      .then((res) => {
        setInitialData({ ...res.data });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <>
      <Home propComponent={<EditGuard initialData={initialData} />} />
    </>
  );
};

export default EditGuardWrapper;
